import {
  usePushNotificationsContext,
  type PushNotificationsContextValue,
  type PushPermission,
} from '@/context/PushNotificationsContext';

export type { PushPermission };
export type UsePushNotificationsReturn = PushNotificationsContextValue;

/**
 * Estado de push compartido por toda la app (Ajustes y drawer no pueden
 * divergir). Ver PushNotificationsContext.
 */
export function usePushNotifications(): UsePushNotificationsReturn {
  return usePushNotificationsContext();
}
